import { render } from "./business-card-qr-modal.vue?vue&type=template&id=3e7bf5be"
import script from "./business-card-qr-modal.vue?vue&type=script&lang=js"
export * from "./business-card-qr-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__